import { useMutation } from '@tanstack/react-query';
import { cancelCheckout } from '../../services/payments';

interface CancelCheckoutParams {
  onSuccess?: () => void | Promise<void>;
  onError?: () => void;
}

export default function useCancelCheckout({
  onSuccess,
  onError,
}: CancelCheckoutParams = {}) {
  return useMutation({
    mutationFn: cancelCheckout,
    onSuccess,
    onError,
  });
}
